// extracted by mini-css-extract-plugin
export default {"styledTable":"StyledTable_styledTable__rTNHE"};